import service_img_1 from "../../assets/images/services/services-1.jpg"
import service_img_2 from "../../assets/images/services/services-2.jpg"
import service_img_3 from "../../assets/images/services/services-3.jpg"
import service_img_4 from "../../assets/images/services/services-4.jpg"
import service_img_5 from "../../assets/images/services/services-5.jpg"

export const classData = [
    {
        id: 1,
        src: service_img_1,
        service_name: "HeartSaver CPR (AHA Certification)",
        service_date: "September 29, 2026 | 6pm",
        service_details: "HeartSaver is a training that includes CPR, AED, and First Aid.",
        link: "/cpr-details",
        dates: [
            { value: "September 29, 2026 | 6pm", label: "September 29, 2026 | 6pm" }, 
            
        ]
    },
    {
        id: 2,
        src: service_img_2,
        service_name: "Enhanced Concealed Carry Class",
        service_date: "September 5, 2026 | 9 - 5 PM",
        service_details: "Real-world tactics from an experienced instructor as well as certification to be able to acquire your Enhanced Concealed Carry permit from the state of Mississippi.",
        link: "/ccw-details",
        dates: [
           
            { value: "September 5, 2026 | 9 - 5 PM", label: "September 5, 2026 | 9 - 5 PM" },
        ]
    },
    {
        id: 3,
        src: service_img_3,
        service_name: "Basic Life Support (BLS) Training",
        service_date: "September 29, 2026 | 6pm",
        service_details: "BLS is a training that includes CPR and AED.",
        link: "/bls-details",
        dates: [
            { value: "September 29, 2026 | 6pm", label: "September 29, 2026 | 6pm" },
            
           
        ]
    },
     {
        id: 4,
        src: service_img_5,
        service_name: "K-12 CPR Training",
        service_date: "September 29, 2026 | 6pm",
        service_details: "CPR K-12 is for students, faculty, and staff.",
        link: "/k12-details",
        dates: [
            { value: "September 29, 2026 | 6pm", label: "September 29, 2026 | 6pm" },
           
        ]
    },

    {
        id: 5,
        src: service_img_2,
        service_name: "Tactical Pistol Class 1", 
        service_date: "TBD",
        service_details: "Tactical Pistol Class 1 is a comprehensive, course designed to build a solid foundation for shooters of all experience levels.",
        link: "/tp1-details",
        dates: [
            { value: "TBD", label: "TBD" },

        ]
    },
]

// Updated function to get service details
export const getServiceDate = (id) => {
    return classData.find(classItem => classItem.id === id)?.service_date;
};

export const getServiceDetails = (id) => {
    return classData.find(classItem => classItem.id === id)?.service_details;
};
// New function to get complete service data including dates
export const getServiceData = (id) => {
    return classData.find(classItem => classItem.id === id);
};